export default {
    activity: 'Loading Data...',
    addToMyAnalogModalDesc: 'myAnalogの製品セクション（通知受け取り）、既存／新規プロジェクトに製品を追加する。',
    addToMyAnalogModalDescTable: 'myAnalogのパラメトリック検索、既存／新規プロジェクトにモデルを追加する',
    addToMyAnalogDropdownTitle: '製品の追加先',
    addToMyAnalogDropdownTitleTable: '全モデルの追加先',
    myAnalogProjectProduct: 'myAnalogの製品',
    myAnalogProjectTable: 'myAnalogのパラメトリック検索',
    myAnalogNewProject: '新規プロジェクト',
    createNewProject: '新規プロジェクトを作成',
    projectName: 'プロジェクト名',
    projectNameTakenError: 'このプロジェクト名はすでに使われています。別のプロジェクト名を使ってください。',
    receivePcnPdnNotifications: '全製品モデルのPCN/PDN通知を受け取る',
    projectDescription: '説明',
    tableName: 'テーブル名',
    note: '注',
    button: {
        and: 'AND',
        blanks: 'Blanks',
        cancel: 'キャンセル',
        confirm: '確認',
        compare: 'Compare',
        default: 'デフォルト',
        deselectAll: 'すべての選択を解除',
        downloadToExcel: 'エクセルにダウンロード',
        feedBack: '意見または感想を送る',
        filters: {
            minimize: 'フィルタを非表示',
            maximize: 'フィルタを全表示',
            hide: 'フィルタを非表示にする',
            show: 'フィルタを表示',
            reset: 'リセット'
        },
        hide: 'HIDE',
        last: 'Last',
        next: 'Next',
        ok: 'OK',
        or: 'OR',
        parameters: {
            choose: 'パラメータを選ぶ',
            all: 'すべて選択'
        },
        previous: 'Previous',
        quickTips: 'Quick Tips',
        reset: 'リストを元に戻す',
        save: 'myAnalogに保存',
        selectAll: 'すべて選択',
        share: 'シェア',
        showAll: 'Show All',
        sortByNewest: '新着順にソート',
        toggleDescription: 'Toggle Description Column',
        toggleHardware: 'Toggle Hardware Column',
        toggleStatus: 'Toggle Status Column',
        toggleTools: 'Toggle Tools Column',
        copyLink: 'リンクをコピーする',
        copied: 'コピー',
        viewParts: '{count}個のパーツを表示',
        addedToMyAnalog: 'myAnalogに追加',
        addToMyAnalog: 'myAnalogに追加',
        addToMyCart: 'カートに追加',
        viewDataSheet: 'データシートはこちら',
        dragAndDrop: 'ドラッグ＆ドロップ',
        hideColumn: '非表示にする',
        sort: '並べ替え',
        sortAsc: '昇順',
        sortDesc: '降順'
    },
    excel: {
        columnName: 'Column Name',
        cover: 'Cover',
        dateCreated: 'エクセルの生成完了',
        display: {
            raw: 'Raw Data Display',
            web: 'Web Display'
        },
        filename: 'ADIパラメトリックサーチ',
        filter: {
            conditions: 'Filter Conditions',
            values: 'Filter Values',
            none: 'None'
        },
        productType: 'Product Type',
        webLink: 'Web Link'
    },
    footnote: {
        pricing: {
            disclosure: '* 価格は1個当たりの米ドルで、米国内における販売価格（FOB）で表示されておりますので、予算のためにのみご使用いただけます。　また、その価格は変更されることがあります。米国以外のお客様への価格は、輸送費、各国の税金、手数料、為替レートにより決定されます。価格・納期等の詳細情報については、弊社正規販売代理店または担当営業にお問い合わせください。',
            evaluationBoardsAndKits: '評価用ボードおよび評価用キットの表示価格は1個構成としての価格です。 ',
            unavailable: '** 価格情報については、製品ページよりご覧ください。'
        }
    },
    filterParts: 'Filter Parts',
    checkDistributorInventory: 'Check Distributor Inventory',
    inputs: {
        defaultPlaceholder: 'Filter {name}'
    },
    link: {
        downloadDataSheet: 'データ・シートをダウンロード',
        viewDataSheet: 'データシートはこちら',
        sampleAndBuy: 'サンプル請求＆オンライン購入',
        viewDocumentation: 'ドキュメントはこちら'
    },
    new: 'NEW',
    noResults: '該当するデータはありません。',
    pageReq: 'You cannot enter a value greater or less than the number of available pages.',
    partNumber: '製品番号',
    parts: '部品',
    tooltip: {
        referenceCircuit: '実用回路',
        evaluationBoard: '評価用ボード'
    },
    totalPages: '/ {total}',
    valuesSelected: '選択済の値',
    selectOneOrMore: '1つ以上のオプションを選択します',
    recommendedNewDesigns: '新しいデザインにおすすめ',
    items: '件',
    resultPerPage: 'ページあたりの表示件数',
    page: 'ページ',
    of: '/'
};